const products =  {
        
        "prod1": {
            "name": "HHC",
            "type": "hhc",
            "picture": "shop420tgk/hhc_new.webp",
            "price": false,   // Add the actual price here
            "desc": "🚨 Увага: цей продукт містить 100% HHC. 🌿 Ідеальний вибір в Україні! Підходить для тих, хто шукає зняття стресу, 👍 позитивно впливає на сон та загальне розслаблення. 💤", 
            "taste": 'Hybrid',   // Add the actual price here
            "variants": ['0,5 мл. - 25 €','1 мл. - 💰 43 €','2 мл. - 65 €', '3 мл. - 95 €', 'Опт. знижка:  📩 у ЛС'],
            "usb": true,   // Add the actual price here
            "concentrate": ['HHC'],
            "volume": '🔋 1 ml.',   // Add the actual price here
            // Add other attributes as needed
        },
        /* "prod2": {
            "name": "YABBA DABBA DOO",
            "picture": "shop420tgk/yabba.webp",
            "price": false,   // Add the actual price here
            "desc": "🏃 Викликає приємне пробудження, наповнене розслабленою гармонією. Свідомість прокидається, але з відчуттям приємного спокою, забираючи з собою втому і сонливість 😌", 
            "taste": 'Sativa',   // Add the actual price here
            "variants": ['1 шт. - 💰 47 €','Від 10 шт. - 42 €', 'Від 20 шт. - 39 €', 'Від 50 шт. - 36 €', 'Від 100 шт. - 34 €'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 2️⃣0️⃣%', 'HHC: 8️⃣0️⃣%'],
            "volume": '🔋 1 ml.',   // Add the actual price here
            // Add other attributes as needed
        },*/
        // "prod3": {
        //     "name": "OASIS",
        //     "picture": "shop420tgk/oasis.webp",
        //     "price": false,   // Add the actual price here
        //     "desc": "🌟 OASIS: Відкрийте для себе новий рівень енергії. 🌀 OASIS несе атмосферу спокою та активності. 🧘‍♂️ Цей девайс - ідеальний супутник для тих, хто цінує глибоку енергію созерцання. 🛡", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['1 шт. - 💰 52 €','Від 10 шт. - 47 €', 'Від 20 шт. - 44 €', 'Від 50 шт. - 41 €', 'Від 100 шт. - 38 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['THC: 4️⃣0️⃣%', 'HHC: 6️⃣0️⃣%'],
        //     "volume": '🔋 1 ml.',   // Add the actual price here
        //     // Add other attributes as needed
        // },
        "prod4": {
            "name": "PINAPPLE EXPRESS",
            "type": "thc",
            "picture": "shop420tgk/pineapple.webp",
            "price": false,   // Add the actual price here
            "desc": "🌿 З цим пристроєм ви отримаєте потужний заряд енергії, який буде змішаний з гармонійним релаксом, ніби ви поїхали далеко від міського шуму 🏔️", 
            "taste": 'Sativa',   // Add the actual price here
            "variants": ['0,5 мл. - 34 €', '1 мл. - 💰 55 €','2 мл. - 85 €', 'Опт. знижка:  📩 у ЛС'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC'],
            "volume": '🔋 1 ml.',   // Add the actual price here

            // Add other attributes as needed
        },
        // "prod5": {
        //     "name": "WHITE WIDOW",
        //     "picture": "shop420tgk/ww.webp",
        //     "price": false,   // Add the actual price here
        //     "desc": "🌿 Цей девайс затуманює розум, ви одразу зрозумієте що зіткнулись із достойним суперником! 🏔️", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['1 шт. - 💰 59 €','Від 10 шт. - 54 €', 'Від 25 шт. - 51 €', 'Від 50 шт. - 48 €', 'Від 100 шт. - 45 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['THC: 8️⃣0️⃣%', 'HHC: 2️⃣0️⃣%'],
        //     "volume": '🔋 1 ml.',   // Add the actual price here

        //     // Add other attributes as needed
        // },
        "prod6": {
            "name": "ESCOBAR",
            "type": "thc",
            "picture": "shop420tgk/escobar.webp",
            "price": false,   // Add the actual price here
            "desc": "👍 Це вейп, який освіжає з відтінком свіжої луговини. Цей продукт ідеально підходить для активних пригод - чи то спортивна гра, чи похід у гори. 🏞️🚵‍♂️", 
            "taste": 'Sativa',   // Add the actual price here
            "variants": ['0,5 мл. - 40 €', '1 мл. - 💰 61 €','2 мл. - 99 €', '3 мл. - 125 €', 'Опт. знижка:  📩 у ЛС'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC'],
            "volume": '🔋 1 ml.',   // Add the actual price here
        },

        /* "prod7": {
            "name": "ESCOBAR HELL",
            "picture": "pod_hell.webp",
            "price": false,   // Add the actual price here
            "desc": "💨 З цією курилкою ви насолодитеся миттєвостями, проведеними з друзями чи наодинці. Кожен димок запалює ідеї, перетворюючи будні на яскраві враження. 🔥🎨", 
            "taste": 'Sativa',   // Add the actual price here
            "variants": ['1 шт. - 💰 66 €', '📩 Інша кількість - у ЛС'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 9️⃣2️⃣%', 'HHC: 0️⃣%'],
            "volume": '🔋 1 ml.',   // Add the actual price here
        }, */
        "prod8": {
            "name": "ESCOBAR DOOM",
            "type": "thc",
            "picture": "pod_doom.webp",
            "price": false,   // Add the actual price here
            "desc": "🌬️ Ця курилка дарує миті, наповнені яскравими емоціями. З кожним вдихом відчуваєш свіжість і легкість, наче весна пробуджує все навколо. 🌿🌞", 
            "taste": 'Sativa',   // Add the actual price here
            "variants": ['0,5 мл. - 44 €', '1 мл. - 💰 69 €','2 мл. - 105 €', '3 мл. - 140 €'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC'],
            "volume": '🔋 1 ml.',   // Add the actual price here
        },
        "prod9": {
            "name": "DIABLO PRO+",
            "type": "thc",
            "picture": "pod_diablo.webp",
            "price": false,   // Add the actual price here
            "desc": "🌿 Цей вейп освіжає з відтінком лугових трав, ідеально підходить для активних пригод — від спортивної гри до походу в гори. 🏞️🏃‍♂️", 
            "taste": 'Sativa',   // Add the actual price here
            "variants": ['0,5 мл. - 47 €', '1 мл. - 💰 74 €','2 мл. - 115 €', '3 мл. - 150 €'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC'],
            "volume": '🔋 1 ml.',   // Add the actual price here
        },
        "prod10": {
            "name": "Mix TGK мармелад",
            "type": "edibles",
            "picture": "shop42update/bear1.jpeg",
            "price": false,   // Add the actual price here
            "desc": "Пропитка містить 60 мг ТНС; для однієї людини достатньо 1–2 одиниць. Мінімальне замовлення — від 5 штук.", 
            "taste": 'Sativa',   // Add the actual price here
            "variants": ['1 шт. - 5 €', '5 шт. - 💰 25 €'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 1️⃣0️⃣0️⃣%', 'HHC: 0️⃣%'],
            "volume": '🏆 60 мг./шт.',   // Add the actual price here
        },
        // "prod11": {
        //     "name": "F+ (Cubensis)",
        //     "type": "mushrooms",
        //     "picture": "shop42update/cubensis1.png",
        //     "price": false,   // Add the actual price here
        //     "desc": "М’який, але глибокий штам. Початківцям 1,5–3 г, досвідченим 3–5 г. Через 15 хв — кольори, ейфорія, спокій. 🌈", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['5 гр. - 60 €', '10 гр. - 💰 108 €','20 гр. - 199 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['Cubensis'],
        //     "volume": '🍄',   // Add the actual price here
        // },
        // "prod12": {
        //     "name": "Psilo-Natalensis",
        //     "type": "mushrooms",
        //     "picture": "shop42update/nanatelnsis1.png",
        //     "price": false,   // Add the actual price here
        //     "desc": "Рідкісний африканський штам із глибоким духовним впливом. 🍄 Дарує спокій, ясність і єднання з природою. 🌍", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['5 гр. - 75 €', '10 гр. - 💰 130 €','20 гр. - 235 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['Cubensis'],
        //     "volume": '🍄',   // Add the actual price here
        // },
        // "prod13": {
        //     "name": "Albino A+ (cubensis)",
        //     "type": "mushrooms",
        //     "picture": "shop42update/albino1.png",
        //     "price": false,   // Add the actual price here
        //     "desc": "М’який, світлий штам Cubensis, що розкриває інтуїцію, гармонію й глибоке сприйняття. Без алкоголю, спокій, музика. 🍄", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['5 гр. - 70 €', '10 гр. - 💰 130 €','20 гр. - 225 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['Cubensis'],
        //     "volume": '🍄',   // Add the actual price here
        // },
        // "prod14": {
        //     "name": "Jamaica (Hymenogastraceae)",
        //     "type": "mushrooms",
        //     "picture": "shop42update/jamaica1.png",
        //     "price": false,   // Add the actual price here
        //     "desc": "Рідкісні 🍄 Jamaica (Hymenogastraceae) відкривають глибини свідомості, дарують емоційні видіння, сміх і сльози, очищують розум, ведуть до істини, внутрішнього спокою й прозріння🌈", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['5 гр. - 80 €', '10 гр. - 💰 150 €','20 гр. - 270 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['Jamaica'],
        //     "volume": '🍄',   // Add the actual price here
        // },
        // "prod15": {
        //     "name": "Golden Teacher",
        //     "type": "mushrooms",
        //     "picture": "shop42update/golden1.png",
        //     "price": false,   // Add the actual price here
        //     "desc": "Класичний і мудрий штам Cubensis. 🍄 Початківцям 1,5–3 г, досвідченим 3–5 г. Дає тепле світло, усвідомлення й глибокий внутрішній спокій. 🌞", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['5 гр. - 65 €', '10 гр. - 💰 120 €','20 гр. - 222 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['Cubensis'],
        //     "volume": '🍄',   // Add the actual price here
        // },
        // "prod16": {
        //     "name": "Lipa Yai (Thai-cubensis)",
        //     "type": "mushrooms",
        //     "picture": "shop42update/lipa1.png",
        //     "price": false,   // Add the actual price here
        //     "desc": "Рідкісний штам, що дарує радість, любов, внутрішню свободу, гармонію, прозріння, чіткість думок, спокій, глибоке бачення і єдність із Всесвітом.", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['5 гр. - 80 €', '10 гр. - 💰 150 €','20 гр. - 275 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['Lipa Yai'],
        //     "volume": '🍄',   // Add the actual price here
        // },
        // "prod17": {
        //     "name": "🍭 Цукерки з 🍄",
        //     "type": "mushrooms",
        //     "picture": "shop42update/candy1.jpeg",
        //     "price": false,   // Add the actual price here
        //     "desc": "Розчиняються в роті, огортаючи теплом і ніжністю. Світ стає яскравішим, думки — чистішими, а душа відчуває легкість, любов і глибокий спокій.", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['1,5 гр. - 30 €', '3 гр. - 💰 50 €','5 гр. - 65 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['Cubensis'],
        //     "volume": '🍄',   // Add the actual price here
        // },
        /* "prod10": {
            "name": "ESCOBAR White",
            "picture": "pod_white.webp",
            "price": false,   // Add the actual price here
            "desc": "🏞️🏃‍♂️🌊 Курилка дарує хвилі бадьорості, наче морський бриз. Це не просто смак, а традиція в кожній затяжці. 🔥🌬️", 
            "taste": 'Sativa',   // Add the actual price here
            "variants": ['1 шт. - 💰 99 €', '📩 Інша кількість - у ЛС'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 9️⃣2️⃣%', 'HHC: 0️⃣%'],
            "volume": '🔋🔋 2 ml. - 600 тяг',   // Add the actual price here
        }, */

        // "prod6": {
        //     "name": "ESCOBAR LEMON 🍋",
        //     "picture": "shop420tgk/esco.webp",
        //     "price": false,   // Add the actual price here
        //     "desc": "👍 Це вейп, який освіжає з відтінком свіжої луговини. Цей продукт ідеально підходить для активних пригод - чи то спортивна гра, чи похід у гори. 🏞️🚵‍♂️", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['1 шт. - 💰 61 €','Від 10 шт. - 53 €', 'Від 20 шт. - 48.5 €', 'Від 50 шт. - 46.5 €', 'Від 100 шт. - 44.5 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['THC: 9️⃣2️⃣%', 'HHC: 0️⃣%'],
        //     "volume": '🔋 1 ml.',   // Add the actual price here
        // },
        // "prod6": {
        //     "name": "WAX Co2, THC 96% Каліфорнія",
        //     "picture": "shop420tgk/thc.webp",
        //     "price": false,   // Add the actual price here
        //     "desc": " 🏞️ Екстракція WAX Co2, THC 96%, імпорт Каліфорнія 🚵‍♂️ Картриджі на основі сертифікованого ТГК, з використанням терпенів зі Швейцарії. (Не використовується пропіленгліколь, гліцерин та інші шкідливі речовини!)🌞", 
        //     "taste": 'Sativa',   // Add the actual price here
        //     "variants": ['1 вейп - 💰 68 €','1 картридж - 60 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['THC: 9️⃣6️⃣%', 'HHC: 0️⃣%'],
        //     "volume": '0.7 ml.',   // Add the actual price here
            
        // },
        // "prod7": {
        //     "name": "WAX",
        //     "picture": "shop420tgk/wax.webp",
        //     "price": false,   // Add the actual price here
        //     "desc": "🔥 Чистий WAX. 🚫 Заборонено новачкам. Не можеш пробити свій толер? 😓 Ми віришили це питання. 💪 1-2 тяги та ти у тонусі! 🚀", 
        //     "taste": 'Gelato',   // Add the actual price here
        //     "variants": ['1 шт. / 0.5 мл. - 54 €', '2️ шт. / 1 мл. - 90 €'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['WAX: 1️⃣0️⃣0️⃣%'],   // Add the actual price here
        //     "volume": '🔋 1 ml.',   // Add the actual price here
        //     // Add other attributes as needed
        // },
        // "prod131": {
        //     "name": "ESCOBAR",
        //     "picture": "shop420tgk/2ml.webp",
        //     "price": false,   // Add the actual price here
        //     "desc": "🌈🎉 Це топ товар! Новий дизайн із неперевершеним терпеновим профілем 🍋 Тепер у форматі 2 мл.!", 
        //     "taste": 'Gelato',   // Add the actual price here
        //     "variants": ['1 шт. - 99€', '2️ шт.+ - звертайтесь'],
        //     "usb": true,   // Add the actual price here
        //     "concentrate": ['THC: 1️⃣0️⃣0️⃣%'],   // Add the actual price here
        //     "volume": '🔋🔋 2 ml.',   // Add the actual price here
        //     // Add other attributes as needed
        // },
        /* "prod113": {
            "name": "THC Mix",
            "picture": "shop420tgk/3ml.webp",
            "price": false,   // Add the actual price here
            "desc": "🌈🎉 Це топ товар! Новий дизайн із неперевершеним терпеновим профілем 🍋 Тепер у форматі 3 мл.!", 
            "taste": 'Gelato',   // Add the actual price here
            "variants": ['1 шт. - 145€', '2️ шт.+ - звертайтесь'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 1️⃣0️⃣0️⃣%'],   // Add the actual price here
            "volume": '🔋🔋🔋 3 ml.',   // Add the actual price here
            // Add other attributes as needed
        }, 
        "prod8": {
            "name": "THC Jelly",
            "picture": "shop420tgk/green.webp",
            "price": false,   // Add the actual price here
            "desc": "🍬 Наш асортимент включає різноманітні смаки, починаючи від цитрусових екстрактів до солодких ягідних композицій.", 
            "taste": 'Gelato',   // Add the actual price here
            "variants": ['1 шт. / 3.6 €', '2 шт.+ - звертайтесь'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 5️⃣%'],   // Add the actual price here
            "volume": '🔋 1 ml.',   // Add the actual price here
            // Add other attributes as needed
        }, */
        /* "prod9": {
            "name": "THC Slim",
            "picture": "shop420tgk/slim.webp",
            "price": false,   // Add the actual price here
            "desc": "🔥 Ви знайдете тут не лише чудовий вибір, але й можливість насолодитися унікальним експериментуванням з різними смаками та ефектами 🚀", 
            "taste": 'Gelato',   // Add the actual price here
            "variants": ['1 шт. / 3.9 €', '2️ шт.+ - звертайтесь'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 5️⃣%'],   // Add the actual price here
            "volume": '🔋 1 ml.',   // Add the actual price here
            // Add other attributes as needed
        },
        "prod10": {
            "name": "THC Cherry",
            "picture": "shop420tgk/red.webp",
            "price": false,   // Add the actual price here
            "desc": "🍬 Кожне желе - це не тільки джерело задоволення, а й можливість насолодитися перевагами конопель у найзручнішій формі.", 
            "taste": 'Gelato',   // Add the actual price here
            "variants": ['1 шт. / 3.6 €', '2️ шт.+ - звертайтесь'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 5️⃣%'],   // Add the actual price here
            "volume": '🔋 1 ml.',   // Add the actual price here
            // Add other attributes as needed
        },
        "prod11": {
            "name": "THC Mix",
            "picture": "shop420tgk/mix.webp",
            "price": false,   // Add the actual price here
            "desc": "🔥 виготовлені з найвищої якості інгредієнтів, що забезпечують вам чистий, безпечний та приємний досвід. 🌈🎉", 
            "taste": 'Gelato',   // Add the actual price here
            "variants": ['1 шт. / 3.9 €', '2️ шт.+ - звертайтесь'],
            "usb": true,   // Add the actual price here
            "concentrate": ['THC: 5️⃣%'],   // Add the actual price here
            "volume": '🔋 1 ml.',   // Add the actual price here
            // Add other attributes as needed
        },*/
    }    

export default products